import  i18n  from '../src/i18n';

export default {
    ref_brouette: {
        question: i18n.t("Connaissezvouslareferencedevotrebrouette"),
        pageName: i18n.t("Referencedelabrouette"),
        titre: i18n.t("Referencedelabrouette"),
        type: "box",
        breadcrumbLabel: i18n.t("Referencebrouette"),
        options: [
            {
                name: i18n.t("OUI"),
                value: "referenceRoueConnue",
                breadcrumbLabel: i18n.t("Jeconnaislareference"),
                images: ['/wp-content/uploads/2022/01/personnage-haemmerlin-positif.jpg'],

            },
            {
                name: i18n.t("NON"),
                value: "type_de_piece",
                breadcrumbLabel: i18n.t("Jeneconnaispaslareference"),
                images: ['/wp-content/uploads/2022/01/personnage-haemmerlin-interrogatif.jpg'],

            },
        ],
    },
    type_de_piece: {
        // question: "Que recherchez-vous ?",
        titre: i18n.t("Piecesderechange"),
        verbatim: i18n.t("Querecherchezvous"),
        type: "box",
        options: [
            {
                name: i18n.t("uneNouvelleRoue"),
                value: "unknown_ref",
                breadcrumbLabel: i18n.t("Roues"),
                images: ['/wp-content/uploads/drupal/product/image/ROUE PF 34_4.jpg'],

            },
            {
                name: i18n.t("Unenouvellecaisse"),
                value: "caisses",
                breadcrumbLabel: i18n.t("Caisses"),
                images: ['/wp-content/uploads/drupal/product/image/CAISSE DE RECHANGE PRO SELECT BATI PLUS 110 RENO PEINTE JAUNE.jpg'],

            },
            {
                name: i18n.t("Despoignees"),
                value: "poignees",
                breadcrumbLabel: i18n.t("Poignees"),
                images: ['/wp-content/uploads/drupal/product/image/Zoom poignee bi-matiere sur chassis peint_51.jpg'],

            },
            {
                name: i18n.t("Desaccessoires"),
                value: "accessoires",
                breadcrumbLabel: i18n.t("Accessoires"),
                images: ['/wp-content/uploads/2022/01/BLISTER-VISSERIE-ROUE.jpg'],

            },
        ],
    },
    referenceRoueConnue: {
        type: "input",
        titre: i18n.t("Veuilleztaperlareferencedevotrebrouette"),
        question: i18n.t("Referencedelabrouettequestion"),
        value: "result",
        breadcrumbLabel: i18n.t("Resultat")
    },
    roueGonflee: {
        type: "box",
        titre: i18n.t("Inscriptionnoteesurlaroue"),
        question: i18n.t("Quelleinscriptionestnoteesurlaroue"),
        options: [
            {
                name: "4.00/8",
                value: "result",
                answer: ['309010001'],
                breadcrumbLabel: "PF34",
            },
            {
                name: "3.50/8",
                value: "result",
                answer: ['309003306'],
                notice: i18n.t("NousNeVendonsPasCetteRoueEnPieceDeRechange"),
                breadcrumbLabel: i18n.t("Chambreaair"),
            },
            {
                name: "3.00/8",
                value: "result",
                answer: ['309003406'],
                notice: i18n.t("NousNeVendonsPasCetteRoueEnPieceDeRechange"),
                breadcrumbLabel: i18n.t("Chambreaair"),
            }
        ],
    },
    roueGonfleeSansAxe: {
        type: "box",
        titre: i18n.t("Inscriptionnoteesurlaroue"),
        question: i18n.t("Quelleinscriptionestnoteesurlaroue"),
        options: [
            {
                name: "4.00/8",
                value: "result",
                answer: ['309016701'],
                breadcrumbLabel: "PF154",
            },
            {
                name: "3.50/8",
                value: "result",
                answer: ['309051401'],
                breadcrumbLabel: "PF150",
            },
            {
                name: "3.00/8",
                value: "result",
                answer: ['309003406'],
                notice: i18n.t("NousNeVendonsPasCetteRoueEnPieceDeRechange"),
                breadcrumbLabel: i18n.t("Chambreaair"),
            }
        ],
    },
    roueIncrevable: {
        name: "3.50/8",
        value: "result",
        answer: ['309003306'],
        breadcrumbLabel: i18n.t("Chambreeair"),
    },
    unknown_ref: {
        question: i18n.t("JeChercheUneRouePour"),
        titre: i18n.t("Nombrederoue(s)"),
        type: "box",
        options: [
            {
                name: i18n.t("1Roue"),
                value: "nbr_axe",
                breadcrumbLabel: i18n.t("Uneroue"),
                images: ['/wp-content/uploads/drupal/product/image/BATI%20PLUS%20110%20RENO%20ALPHA%20GONFLEE_4.jpg']
            },
            {
                name: i18n.t("2Roues"),
                value: "choix_modele",
                breadcrumbLabel: i18n.t("Deuxroues"),
                images: ['/wp-content/uploads/drupal/product/image/Start%20Twin.jpg']
            },
            {
                name: i18n.t("Saline"),
                value: "result",
                answer: i18n.t("NousnevendonspaslarouedecettebrouetteenpiecederechangesurnotresiteMercidevousrapporcherdundistributeur"),
                breadcrumbLabel: i18n.t("Saline"),
                images: ['/wp-content/uploads/2016/10/PLUME-SALINE.jpg']
            },
            {
                name: i18n.t("DevidoireDiableChariot"),
                value: "roulette",
                breadcrumbLabel: i18n.t("DevidoireDiableChariot"),
                images: ['/wp-content/uploads/drupal/product/image/DIABLE%20946%20G_0.jpg']
            }
        ],
    },
    rouePleine: {
        question: i18n.t("Quelleestlamesuredudiametre"),
        titre: i18n.t("Diametre"),
        type: "box",
        options: [
            {
                name: i18n.t("360mm"),
                value: "result",
                answer: i18n.t("Nestplusdisponible"),
                breadcrumbLabel: i18n.t("Roue360mm"),
            },
            {
                name: i18n.t("400mm"),
                value: "result",
                answer: ['309014501'],
                breadcrumbLabel: i18n.t("Roue400mm"),
            },
        ],
    },
    rouePleineSansAxe: {
        question: i18n.t("Quelleestlamesuredudiametre"),
        titre: i18n.t("Diametre"),
        type: "box",
        options: [
            {
                name: i18n.t("360mm"),
                value: "result",
                answer: ['309013901'],
                breadcrumbLabel: "PF139",
            },
            {
                name: i18n.t("390mm"),
                value: "result",
                answer: ['309031201'],
                breadcrumbLabel: "PF112",
            },
        ],
    },
    axe: {
        question: i18n.t("Queltypederouedesirezvous"),
        titre: i18n.t("Typederoue"),
        type: "box",
        options: [
            {
                name: i18n.t("Rouegonflee"),
                value: "roueGonflee",
                breadcrumbLabel: i18n.t("Unerouegonflee"),
            },
            {
                name: i18n.t("Rouepleine"),
                value: "rouePleine",
                breadcrumbLabel: i18n.t("Unerouepleine"),
            },
            {
                name: i18n.t("Roueincrevable"),
                value: "result",
                // answer: ['309011001'],
                answer: ['309035801'],
                breadcrumbLabel: i18n.t("RoueincrevablePF110"),
            },
        ],
    },
    sansAxe: {
        question: i18n.t("Queltypederouedesirezvous"),
        titre: i18n.t("Typederoue"),
        type: "box",
        options: [
            {
                name: i18n.t("Rouegonflee"),
                value: "roueGonfleeSansAxe",
                breadcrumbLabel: i18n.t("Unerouegonflee"),
            },
            {
                name: i18n.t("Rouepleine"),
                value: "rouePleineSansAxe",
                breadcrumbLabel: i18n.t("Unerouepleine"),
            },
            {
                name: i18n.t("Roueincrevable"),
                value: "result",
                answer: ['309020010'],
                breadcrumbLabel: i18n.t("RoueincrevablePF200"),
            },
        ],
    },
    nbr_axe: {
        question: i18n.t("Votreroueatelleunaxe"),
        titre: i18n.t("Axederoue"),
        type: "box",
        options: [
            {
                name: i18n.t("Unaxe"),
                value: "axe",
                breadcrumbLabel: i18n.t("Avecaxe"),
            },
            {
                name: i18n.t("Sansaxe"),
                value: "sansAxe",
                breadcrumbLabel: i18n.t("Sansaxe"),
            },
        ],
    },
    modele_aktiv: {
        question: i18n.t("Queltypederouedesirezvous"),
        titre: i18n.t("Typederoue"),
        type: "box",
        options: [
            {
                name: i18n.t("Rouegonflee"),
                value: "result",
                answer: ['309051401'],
                breadcrumbLabel: "PF150",
            },
            {
                name: i18n.t("Roueincrevable"),
                value: "result",
                answer: ['309020010'],
                breadcrumbLabel: "PF200",
            },
        ],
    },
    modele_expert: {
        question: i18n.t("Queltypederouedesirezvous"),
        titre: i18n.t("Typederoue"),
        type: "box",
        options: [
            {
                name: i18n.t("Rouegonflee"),
                value: "result",
                answer: ['309010701'],
                breadcrumbLabel: "PF39",
            },
            {
                name: i18n.t("Rouepleine"),
                value: "result",
                answer: ['309013701'],
                breadcrumbLabel: "PF50",
            },
            {
                name: i18n.t("Roueincrevable"),
                value: "result",
                answer: ['309011001'],
                breadcrumbLabel: "PF38",
            },
        ],
    },
    choix_modele: {
        question: i18n.t("Maroueestressembleacemodele"),
        titre: i18n.t("Modele"),
        type: "gallery",
        options: [
            {
                name: "Start Twin",
                value: "result",
                answer: ['309003306'],
                notice: i18n.t("NousnavonspasderouesderechangespourcemodeleMaisnousvousconseillonslachatdunpneuchambreaair"),
                breadcrumbLabel: i18n.t("ModeleStartTwin"),
                images: ['/wp-content/uploads/drupal/product/image/Start%20Twin.jpg'],
            },
             // MODELE AKTIV
            {
                name: "Aktiv Excellium 100 TWIN",
                value: "modele_aktiv",
                breadcrumbLabel: i18n.t("ModeleAktivExcellium100TWIN"),
                images: [
                    '/wp-content/uploads/drupal/product/image/AKTIV%20EXCELLIUM%20100%20TWIN%20GALVA%20GONFLEES_4.jpg',
                ],
            },
            {
                name: "Reverso",
                value: "result",
                answer: ["309051401"],
                breadcrumbLabel: i18n.t("ModeleReverso"),
                images: [
                    '/wp-content/uploads/drupal/product/image/brouette_a_deversement_lateral_reverso_peinte_roues_gonflees.jpg'
                ],
            }, 
            // MODELE EXPERT
            {
                name: "Expert Excellium 160 TWIN",
                value: "modele_expert",
                answer: ['309011001'],
                breadcrumbLabel: i18n.t("ModeleExpertExcellium160TWIN"),
                images: [
                    '/wp-content/uploads/2016/10/EXPERT-TWIN-EXCELLIUM-160-GALVA-GONFLEES.jpg',
                ],
            },
            {
                name: "Expert Excellium 230 TWIN",
                value: "modele_expert",
                breadcrumbLabel: i18n.t("ModeleExpertExcellium230TWIN"),
                images: [
                    '/wp-content/uploads/drupal/product/image/EXPERT%20TWIN%20EXCELLIUM%20230%20GALVA%20GONFLEES.jpg',
                ],
            },
            {
                name: "Expert Excellium 300 TWIN",
                value: "modele_expert",
                breadcrumbLabel: i18n.t("ModeleExpertExcellium300TWIN"),
                images: [
                    '/wp-content/uploads/2016/10/EXPERT-TWIN-EXCELLIUM-300-POLYPRO-GONFLEES.jpg',
                ],
            },
            {
                name: "Expert Premium 150 TWIN",
                value: "modele_expert",
                breadcrumbLabel: i18n.t("ModeleExpertPremium150TWIN"),
                images: [
                    '/wp-content/uploads/2016/10/EXPERT-TWIN-PREMIUM-150-GALVA-GONFLEES.jpg',
                ],
            },
            {
                name: "Pro Select Agricola",
                value: "modele_expert",
                breadcrumbLabel: i18n.t("ModeleProSelectAgricola"),
                images: [
                    '/wp-content/uploads/2016/10/PRO-SELECT-AGRICOLA-2-ROUES-GONFLEES.jpg',
                ],
            },
            {
                name: "Tractoplus",
                value: "modele_expert",
                breadcrumbLabel: i18n.t("ModeleTractoplus"),
                images: [
                    '/wp-content/uploads/drupal/product/image/tractoplus_-_306060401_-_tractable.jpg'
                ],
            },
        ],
    },

    roulette:{
        question: i18n.t("Maroueestressembleacemodele"),
        titre: i18n.t("Modele"),
        type: "gallery",
        options: [
            {
                name: "Chariot 4x4 Garden",
                value: "result",
                answer: ["309011401"],
                breadcrumbLabel: i18n.t("Chariot4X4Garden"),
                images:[
                    '/wp-content/uploads/drupal/product/image/CHARIOT%204x4%20GARDEN_4.jpg'
                ]
            },
            {
                name: "Diable",
                value: "result",
                answer: ["309011901", "309029000"],
                breadcrumbLabel: i18n.t("Diable"),
                images:[
                    '/wp-content/uploads/drupal/product/image/DIABLE%20924%20G_3.jpg'
                ]
            },
            {
                name: "Circus Garden",
                value: "result",
                answer: ["309011901"],
                breadcrumbLabel: i18n.t("Circus Garden"),
                images:[
                    '/wp-content/uploads/drupal/product/image/Circus%20Garden.jpg'
                ]
            },
            {
                name: "Devidoir",
                value: "result",
                answer: ["309011901", "309029000"],
                breadcrumbLabel: i18n.t("Devidoir"),
                images:[
                    '/wp-content/uploads/drupal/product/image/devidoir_2_roues_55m_-_340004101.jpg'
                ]
            },
            {
                name: "Chariot Big Garden",
                value: "result",
                answer: ["309011901", "309029000"],
                breadcrumbLabel: i18n.t("Chariot Big Garden"),
                images:[
                    '/wp-content/uploads/drupal/product/image/big_garden_1.jpg'
                ]
            }
        ]
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Accessoires
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */


    accessoires: {
        question: i18n.t("Jesouhaite"),
        titre: i18n.t("Accessoires"),
        type: "box",
        options: [
            {
                name: i18n.t("DesCoussinetsDeFixationPourRoue"),
                value: "result",
                answer: ['309002506'],
                breadcrumbLabel: i18n.t("CoussinetsDeFixation"),
                images: ['/wp-content/uploads/2022/01/BATI-90-PEINTE-GONFLEE.jpg']
            },
            {
                name: i18n.t("UnAxeDeFixationPourRoue"),
                value: "result",
                answer: ['309027101'],
                breadcrumbLabel: i18n.t("AxeDeFixation"),
                images: ['/wp-content/uploads/2022/01/CLIPSO-EXCELLIUM-100-GALVA-GONFLEE.jpg']
            },
            {
                name: i18n.t("Delavisseriepourroue"),
                value: "result",
                answer: ['309027006'],
                breadcrumbLabel: i18n.t("Delavisseriepourroue"),
                images: ['/wp-content/uploads/2022/01/BLISTER-VISSERIE-ROUE.jpg']
            },
            {
                name: i18n.t("Delavisseriepourcaisse"),
                value: "result",
                answer: ['309029006'],
                breadcrumbLabel: i18n.t("Delavisseriepourcaisse"),
                images: ['/wp-content/uploads/2022/01/BLISTER-VISSERIE-CAISSE.jpg']
            },
            {
                name: i18n.t("Unechambreaairpourroue"),
                value: "chambre_air",
                breadcrumbLabel: i18n.t("Unechambreaairpourroue"),
                images: ['/wp-content/uploads/2022/01/BLISTER-CHAMBRE-A-AIR-380-400-mm.jpg']
            },
            {
                name: i18n.t("BoiteAOutilPourPickupEtPlume100L"),
                value: "result",
                answer: ['309063101'],
                breadcrumbLabel: i18n.t("BoiteAOutil"),
                images: ['/wp-content/uploads/drupal/product/image/boite_a_outils_pick_up.jpg']
            },
        ],
    },
    chambre_air: {
        question: i18n.t("Jesouhaite"),
        titre: i18n.t("Chambreeair"),
        type: "box",
        options: [
            {
                name: i18n.t("Pourrouedebrouette355mm"),
                value: "result",
                answer: ['309003406'],
                breadcrumbLabel: i18n.t("Pourrouedebrouette355mm"),
            },
            {
                name: i18n.t("Pourrouedebrouette400mmou380mm"),
                value: "result",
                answer: ['309003306'],
                breadcrumbLabel: i18n.t("Pourrouedebrouette400mmou380mm"),
            },
        ],
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Poignées
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */


    poignees: {
        type: "box",
        titre: i18n.t("Mercidemesurerlediametredevospoignees"),
        question: i18n.t("Diametredelapoignee"),
        options: [
            {
                name: i18n.t("32mm"),
                value: "result",
                answer: ['309002106'],
                breadcrumbLabel: i18n.t("Poignee32mm"),
            },
            {
                name: i18n.t("Autre"),
                value: "result",
                answer: i18n.t("Nousneproposonspasdepiecesderechangespourcemodele"),
                breadcrumbLabel: i18n.t("Pourrouedebrouette400mmou380mm"),
            },
        ],
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisses
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */

    caisses: {
        question: i18n.t("Jesouhaite"),
        titre: i18n.t("Caisses"),
        type: "box",
        options: [
            // {
            //     name: i18n.t("Caissede90L"),
            //     value: "result",
            //     answer: i18n.t("Nousnevendonspasdecaissederechange90LNousvousproponsdechoisirunecaisse100L"),
            //     breadcrumbLabel: i18n.t("Caisse90L"),
            // },
            {
                name: i18n.t("CaisseEnAcier"),
                value: "caisse_en_acier",
                breadcrumbLabel: i18n.t("CaisseEnAcier"),
            },
            {
                name: i18n.t("CaisseEnPlastique"),
                value: "caisse_en_plastique",
                breadcrumbLabel: i18n.t("CaisseEnPlastique"),
            },
        ],
    },



    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse en Acier
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */


    'caisse_en_acier': {

        question: i18n.t("JeSouhaiteRemplacerUneCaisse"),
        titre: i18n.t("CaissesAcier"),
        type: "box",

        options: [
            {
                name: "85L",
                value: "result",
                notice: i18n.t('NousNeVendonsPasDeCaisseDeRechange90LNousVousProposonsDeChoisirUneCaisse100LSansTrouEtDePercerLesTrousALaBonnePositionParVousMeme'),
                answer: ['309007801'],
                breadcrumbLabel: "85L",
            },
            {
                name: "90L",
                value: "result",
                notice: i18n.t('NousNeVendonsPasDeCaisseDeRechange90LNousVousProposonsDeChoisirUneCaisse100LSansTrouEtDePercerLesTrousALaBonnePositionParVousMeme'),
                answer: ['309007801'],
                breadcrumbLabel: "90L",
            },
            {
                name: "95L",
                value: "result",
                answer: ['309064501'],
                notice: i18n.t('NousNeVendonsPasDeCaisseDeRechange95LNousVousProposonsDeChoisirUneCaisse120L-6Trous'),
                breadcrumbLabel: "95L",
            },
            {
                name: "100L",
                value: "100L",
                breadcrumbLabel: "100L",
            },
            {
                name: "110L",
                value: "110L",
                breadcrumbLabel: "110L",
            },
            {
                name: "120L",
                value: "120L",
                breadcrumbLabel: "120L",
            },
            {
                name: "160L",
                value: "160L",
                breadcrumbLabel: "160L",
            },
            {
                name: "230L",
                value: "230L",
                breadcrumbLabel: "230L",
            },
        ]
    },

    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse 100 L
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */

    '100L':{
        question: i18n.t('NombreDeTrous'),
        titre: i18n.t('Trous'),
        type: "box",
        options: [
            {
                name: i18n.t('4Trous'),
                value: "100L_4_trous",
                breadcrumbLabel: i18n.t('100L4Trous'),
            },
            {
                name: i18n.t('6Trous'),
                value: "100L_6_trous",
                breadcrumbLabel: i18n.t('100L6Trous'),
            },
            {
                name: "SansTrou",
                value: "result",
                answer: ['309007801'],
                breadcrumbLabel: "100LSansTrou",
            },
        ]
    },
    '100L_4_trous': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Peinte'),
                value: "100L_4_trous_peinte",
                breadcrumbLabel: i18n.t('Peinte'),
            },
            {
                name: "GALVA",
                value: "result",
                answer: ['309064101'],
                breadcrumbLabel: "Galva",
            },
        ]
    },

    '100L_4_trous_peinte': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Noire'),
                value: "result",
                answer: ['309064201'],
                breadcrumbLabel: i18n.t('Peinte'),
            },
            {
                name: i18n.t('Jaune'),
                value: "result",
                answer: ['309008901'],
                breadcrumbLabel: "100L - 6 " + i18n.t('trous'),
            },
        ]
    },

    '100L_6_trous': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Peinte'),
                value: "100L_6_trous_peinte",
                breadcrumbLabel: i18n.t('Peinte'),
            },
            {
                name: "GALVA",
                value: "result",
                answer: ['309009801', '309007101'],
                breadcrumbLabel: "Galva",
            },
        ]
    },

    '100L_6_trous_peinte': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Verte'),
                value: "result",
                answer: ['309007201', '309006201'],
                breadcrumbLabel: i18n.t('Verte'),
            },
            {
                name: i18n.t('Noir'),
                value: "result",
                answer: ['309006501'],
                breadcrumbLabel: "100L - 6 " + i18n.t('trous'),
            },
        ]
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse 110 L
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */

    '110L': {

        question: i18n.t("Macaissea"),
        titre: i18n.t("Caisses"),
        type: "box",

        options: [
            {
                name: "4 " + i18n.t('trous'),
                value: "110L_4_trous",
                breadcrumbLabel: i18n.t('4Trous'),
            },
            {
                name: "6 " + i18n.t('trous'),
                value: "result",
                answer: i18n.t('Nousnevendonspasdecaissesderechanges110litres6trous'),
                breadcrumbLabel: i18n.t('6Trous'),
            },
        ]
    },


    '110L_4_trous': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Peinte'),
                value: "result",
                answer: ['309008701'],
                breadcrumbLabel: i18n.t('Peinte'),
            },
        ]
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse 120 L
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */



    '120L': {

        question: i18n.t("Macaissea"),
        titre: i18n.t("Caisses"),
        type: "box",

        options: [
            {
                name: "4 " + i18n.t('trous'),
                value: "result",
                answer: ['309064401'],
                breadcrumbLabel: i18n.t('4Trous'),
            },
            {
                name: "6 " + i18n.t('trous'),
                value: "result",
                answer: ['309064501'],
                breadcrumbLabel: i18n.t('6Trous'),
            },
        ]
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse 160 L
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */


    '160L': {

        question: i18n.t("Macaissea"),
        titre: i18n.t("Caisses"),
        type: "box",

        options: [
            {
                name: "4 " + i18n.t('trous'),
                value: "result",
                answer: i18n.t('Nousnevendonspasdepiecesderechanges160L4trous'),
                breadcrumbLabel: i18n.t('4Trous'),
            },
            {
                name: "6 " + i18n.t('trous'),
                value: "160L_6_trous",
                breadcrumbLabel: i18n.t('6Trous'),
            },
        ]
    },

    '160L_6_trous': {

        question: i18n.t('Typedecaisse'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Peinte'),
                value: "result",
                answer: ['309005501'],
                breadcrumbLabel: i18n.t('Peinte'),
            },
            {
                name: "GALVA",
                value: "result",
                answer: ['309007301'],
                breadcrumbLabel: "Galva",
            },
        ]
    },


    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse 230 L
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */


    '230L': {

        question: i18n.t("Macaissea"),
        titre: i18n.t("Caisses"),
        type: "box",

        options: [
            {
                name: "4 " + i18n.t('trous'),
                value: "result",
                answer: i18n.t('Nousnevendonspasdecaissederechange230L4trous'),
                breadcrumbLabel: i18n.t('4Trous'),
            },
            {
                name: "6 " + i18n.t('trous'),
                value: "result",
                answer: ['309007401'],
                breadcrumbLabel: i18n.t('6Trous'),
            },
        ]
    },

        /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Caisse en Plastique
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */
    'caisse_en_plastique': {

        question: i18n.t("JeSouhaiteRemplacerUneCaisse"),
        titre: i18n.t("CaissesPlastique"),
        type: "box",

        options: [
            {
                name: "100L",
                value: "100L_plastique",
                breadcrumbLabel: "100L",
            },
            {
                name: "110L",
                value: "110L_plastique",
                breadcrumbLabel: "110L",
            },
            {
                name: "120L",
                value: "result",
                notice: i18n.t('NousNeVendonsPasDeCaisseDeRechange120LPlastiqueNousVousProposonsDeChoisirUneCaisse120LAcier'),
                answer: ['309008701'],
                breadcrumbLabel: "120L",
            },
            {
                name: "300L",
                value: "result",
                answer: i18n.t('NousNeVendonsPasDeCaisseDeRechange300L'),
                breadcrumbLabel: "300L",
            },
        ]
    },

    '100L_plastique': {

        question: i18n.t('ModelePlastique'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('Anis'),
                value: "result",
                answer: ['219000056'],
                breadcrumbLabel: i18n.t('Anis'),
            },
            {
                name: i18n.t('Corail'),
                value: "result",
                answer: ['219000054'],
                breadcrumbLabel: i18n.t('Corail'),
            },
        ]
    },

    '110L_plastique': {

        question: i18n.t('EstCeUneBrouetteSaline'),
        titre: i18n.t('Type'),
        type: "box",

        options: [
            {
                name: i18n.t('OUI'),
                value: "result",
                answer: i18n.t('NousNeVendonsPasDeCaisseDeRechange110LPourLesBrouettesSalines'),
                breadcrumbLabel: i18n.t('EstUneBrouetteSaline'),
            },
            {
                name: i18n.t('NON'),
                value: "result",
                answer: ['309063401'],
                breadcrumbLabel: i18n.t('NEstPasUneBrouetteSaline'),
            },
        ]
    },
    /*
    ▰▰▰▰▰▰▰▰▰▰▰▰
    Type result
    ▰▰▰▰▰▰▰▰▰▰▰▰
     */

    result: {
        type: 'result',
    }
};
